import {field} from '../field'
import {mergeConfig} from '../../configStore'
import type {ObjectField, FieldReturn} from '../../types'

export const object = (props: ObjectField, mergeProps?: Partial<ObjectField>): FieldReturn =>
  field('object', mergeConfig('object', props, mergeProps))
